import { Route, RouteGroup } from '@billow/easy-route'
import { concat } from 'lodash'

export default concat(

  RouteGroup({
    middleware: ['auth', 'active-subscriber'],
    routes: [
      Route('/audits', 'audits', () => import('@/views/audit/Index.vue')),
      Route('/audit', 'new-audit', () => import('@/views/audit/Create.vue')),
      Route('/audits/:audit', 'audit-manager', () => import('@/views/audit/manager/Manager.vue')),
    ]
  }),
)